'use strict';

module.exports = {
  template: require('./performance-review-invite.html'),
  controller: require('./performance-review-invite.controller'),
  controllerAs: 'vm',

  bindings: {
    me: '<',
    data: '<',
    round: '<',
    basis: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-invite/performance-review-invite/index.js
 ** module id = 247
 ** module chunks = 0
 **/